export default __webpack_public_path__ + "static/media/javascript.ba077c09.png";